const waitForGlobal = (globalName, timeout = 500) => {
  return new Promise((resolve, reject) => {
    let waited = 0;

    const wait = interval => {
      setTimeout(() => {
        waited += interval;

        if (window[globalName] !== undefined) {
          return resolve();
        }

        if (waited >= timeout * 1000) {
          return reject(new Error('waitForGlobal TIMEOUT'));
        }

        wait(interval * 2);
      }, interval);
    };

    wait(30);
  });
};

export default waitForGlobal;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/wait_for_global.js